import script from "./file-upload-custom.vue?vue&type=script&setup=true&lang=js"
export * from "./file-upload-custom.vue?vue&type=script&setup=true&lang=js"

import "./file-upload-custom.vue?vue&type=style&index=0&id=25f20929&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25f20929"]])

export default __exports__